import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "feelgrid.humidity.icon",
  "use": "feelgrid.humidity.icon-usage",
  "viewBox": "0 0 20 36.302",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 36.302\" id=\"feelgrid.humidity.icon\"><path data-name=\"Path 1093\" d=\"M167.05,85.206l-9.24-22.27-9,21.914-.237.474a10.111,10.111,0,0,0,5.449,13.149,9.938,9.938,0,0,0,13.03-5.449A10.49,10.49,0,0,0,167.05,85.206Zm-4.5-3.554a1.055,1.055,0,0,1,1.3.592l1.066,2.843a1.055,1.055,0,0,1-.592,1.3c-.118,0-.237.118-.355.118a1.208,1.208,0,0,1-.948-.592l-1.066-2.961A1.06,1.06,0,0,1,162.549,81.652Zm-4.383,15.636a.948.948,0,0,1,0-1.9,5.94,5.94,0,0,0,5.923-5.923.948.948,0,0,1,1.9,0A7.888,7.888,0,0,1,158.166,97.288Z\" transform=\"translate(-147.806 -62.936)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/feelgrid.humidity.icon.svg
// module id = ZPS4
// module chunks = 13